import activityList from "../Assets/activities/activityList.json";

export const getUserProgress = () => {
  let progress = localStorage.getItem("progress");
  if (!progress) {
    const worldProgresses = [];
    for (let i = 0; i < 10; i++) {
      worldProgresses.push({
        world: i,
        status: "notStarted",
        dialogueHistory: [],
        nextDialogue: null,
      });
    }
    const acitvityProgresses = [];
    for (let i = 0; i < activityList.length; i++) {
      acitvityProgresses.push({
        name: activityList[i].activity,
        unlocked: false,
      });
    }
    progress = {
      lastWorld: null,
      lastDialogue: null,
      worldProgresses: worldProgresses,
      activityProgresses: acitvityProgresses,
      status: "notStarted",
    };
    localStorage.setItem("progress", JSON.stringify(progress));
    return progress;
  }
  return JSON.parse(progress);
};
export const setUserProgress = (progress) => {
  localStorage.setItem("progress", JSON.stringify(progress));
};
export const getUserProfile = () => {
  let profile = localStorage.getItem("profile");
  if (!profile) {
    profile = {
      name: "Guest",
      pronoun: "",
      gender: "",
    };
    localStorage.setItem("profile", JSON.stringify(profile));
    return profile;
  }
  return JSON.parse(profile);
};
export const setUserProfile = (profile) => {
  localStorage.setItem("profile", JSON.stringify(profile));
};
export const getUserResources = () => {
  let resources = localStorage.getItem("resources");
  if (!resources) {
    resources = {
      resources: [],
    };
    localStorage.setItem("resources", JSON.stringify(resources));
    return resources;
  }
  return JSON.parse(resources);
};

export const setUserResources = (resources) => {
  localStorage.setItem("resources", JSON.stringify(resources));
};

export const resetUserProgress = () => {
  localStorage.removeItem("progress");
};
